<template>
    <div class="section" :class="input.extraClass" :style="input.style">
        <div class="inner">
            <template v-for="(sectionValue, index) in getNestedValue(formValue, input.value)">
                <div :class="input.grid">
                    <template v-for="(sectionInput, index2) in input.forms">
                        <InputField :input="sectionInput" :formValue="sectionValue"></InputField>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import InputField from "./InputField.vue"
    export default {
        components: {
            InputField
        },
        name: "SectionArraySimple",
        props: {
            input: {
                type: Object,
                required: true
            },
            formValue: {
                type: Object,
                required: false
            }
        },
        mounted() {

        },
        methods: {
        }
    }
</script>
